// @mui
import type { StackProps } from '@mui/material';

import { Stack, Tooltip, Typography } from '@mui/material';

//
import Iconify from '../../iconify';

// ----------------------------------------------------------------------

const SPACING = 2.5;

interface Props extends StackProps {
  title: string;
  tooltip?: string;
}

const Block = ({ children, sx, title, tooltip, ...other }: Props) => {
  return (
    <Stack spacing={1.5} sx={{ mb: SPACING, ...sx }} {...other}>
      <Stack
        alignItems="center"
        direction="row"
        sx={{
          color: 'text.secondary',
        }}
      >
        <Typography sx={{ fontWeight: 'fontWeightMedium' }} variant="caption">
          {title}
        </Typography>

        {tooltip && (
          <Tooltip title={tooltip}>
            <Iconify icon="eva:info-outline" sx={{ mx: 0.5 }} width={16} />
          </Tooltip>
        )}
      </Stack>

      {children}
    </Stack>
  );
};

export default Block;
